import React, { useEffect, useState, useRef } from 'react'
import Header from '../../layout/Header'
import CustomModal from '../../modal'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import SpinImageHi from "../../../assets/images/spinImage_hi.png";
import SpinImageMr from "../../../assets/images/spinImage_mr.png";
import SpinImageKa from "../../../assets/images/spinImage_ka.png";
import SpinImageTe from "../../../assets/images/spinImage_te.png";
import SpinImagePb from "../../../assets/images/spinImage_pb.png";
import SpinImageGj from "../../../assets/images/spinImage_gj.png";
import SpinImageTa from "../../../assets/images/spinImage_ta.png";
import SpinImageBn from "../../../assets/images/spinImage_ba.png";
import SpinImageEn from "../../../assets/images/spinImage_en.png";
import ProductId from "../../../assets/images/productId.png";
import packetIcon from "../../../assets/images/packetIcon.jpg";
import stand from "../../../assets/images/stand.jpg";
import CustomRoulette from '../../WheelComponent'
import { useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import Close from "../../../assets/images/cross.png";
import { useDispatch } from "react-redux";
import { spinStatus } from '../../auth/redux/store'
import giftBg from "../../../assets/images/giftBg.png";
import giftBg2 from "../../../assets/images/giftBg2.jpg";
import ReactGA from 'react-ga4';
import { fetchAPI } from '../../service/Encrtyption'
import { Loader } from '../../loader'
import giftBox from '../../../assets/images/giftBox.svg'
import rupeeSymbol from '../../../assets/images/rupee-symbol.svg'
import line from '../../../assets/images/line.png'
import giftbox1 from '../../../assets/images/gift-box 1.png'

const RewardJourney = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();
    const currentLanguage = lang;
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.user);
    const [scanUrl, setScanUrl] = useState("");
    const [scanedDataObject, setScanedDataObject] = useState(false);
    const [spinModalShow, setSpinModalShow] = useState(false);
    const [stopPrizeNumber, setStopPrizeNumber] = useState("");
    const [winBumperGiftsModal, setWinBumperGiftsModal] = useState(false);
    const [allProductsScanned, setAllProductsScanned] = useState(false);
    const [spinDisabled, setSpinDisabled] = useState(false);
    const [eligibletoWinModal, setEligibletoWinModal] = useState(false);
    const [congratulationsModal, setCongratulationsModal] = useState(false);
    const [secondaryRewardMsg, setSecondaryRewardMsg] = useState("");
    const [Data, setData] = useState([]);
    const [titleOneListData, setTitleOneListData] = useState([]);
    const [titleTwoListData, setTitleTwoListData] = useState([]);
    const [wheelItems, setWheelItems] = useState([]);
    const [centerWheelImgUrl, setCenterWheelImgUrl] = useState("");
    const [reqObj, setReqObj] = useState({});
    const [scanning, setScanning] = useState(false);
    const [loading, setLoading] = useState(false);
    const scanResponseData = useSelector((state) => state?.genunityData);
    const scanedData = useSelector((state) => state?.scandataUrl);
    const spinValue = useSelector((state) => state?.spinValue);
    // const mobileNumber = user?.mobileNumber;
    // const customerId = user?.customerId;
    const mbno = sessionStorage.getItem('mbn');
    const cid =  sessionStorage.getItem('cid');
    const productName = sessionStorage.getItem('storedProductName');
    const navigate = useNavigate();
    const genuityCheckData = useSelector((state) => state?.genunityData);
    const totalBars = 10;
    const completedBars = genuityCheckData.scanCount;
    const indicatorPosition = completedBars * 25;
    const [showProceedModal, setShowProceedModal] = useState(false);
    // console.log("genuityCheckData in reward journey", genuityCheckData);

    const totalBoxes = 10;
    const activeCount = genuityCheckData.scanCount;

    const packetTargetDisplay =
        Number(genuityCheckData?.packetTarget ?? genuityCheckData?.targetScanCount ?? totalBoxes) || totalBoxes;

    const primaryMessageBackend = String(
        genuityCheckData?.primaryMessage ?? genuityCheckData?.PrimaryMessage ?? "",
    ).trim();
    const secondaryMessageBackend = String(
        genuityCheckData?.secondaryMessage ?? genuityCheckData?.SecondaryMessage ?? "",
    ).trim();

    const renderBackendMessage = (text) =>
        text ? (
            <span
                dangerouslySetInnerHTML={{
                    __html: String(text).replace(/\r\n|\n|\r/g, "<br />"),
                }}
            />
        ) : null;

    // useEffect(() => {
    //     if (scanedData) {
    //         try {
    //             let result;
    //             if (typeof scanedData === 'string' && scanedData.trim().startsWith('{')) {
    //                 result = JSON.parse(scanedData);
    //             } else if (typeof scanedData === 'string') {
    //                 result = { completeUrl: scanedData };
    //             } else if (typeof scanedData === 'object' && scanedData !== null) {
    //                 result = scanedData;
    //             } else {
    //                 throw new Error('Unsupported scanedData format');
    //             }
    //             setScanedDataObject(result);
    //         } catch (error) {
    //             console.error("Invalid scanned data format:", error);
    //         }

    //     }
    // }, [scanedData]);

    // useEffect(() => {
    //     if (scanedDataObject && Object.keys(scanedDataObject).length > 0) {
    //         const updatedScanedDataObject = {
    //             ...scanedDataObject,
    //             otp: "",
    //             mobileNumber: mbno,
    //             otpVerified: true,
    //             deviceId: "",
    //             deviceType: "WEB",
    //             countryId: 5,
    //             destinationURL: "/customer/saveGenuinityCheckDetails_V2_acviss",
    //             moduleType: productName,
    //         };
    //         setScanUrl(scanedData);
    //         setReqObj(updatedScanedDataObject);
    //         setScanning(false);
    //     }
    // }, [scanedDataObject, scanedData, mbno, productName]);

    // useEffect(() => {

    //     if (reqObj && Object.keys(reqObj).length > 0) {
    //         const getScan = async () => {
    //             setLoading(true);
    //             try {
    //                 const responseData = await fetchAPI(
    //                     process.env.REACT_APP_API_URL_SCAN,
    //                     reqObj,
    //                     {
    //                         customerid: cid,
    //                         mobileNumber: mbno,
    //                         userAuthorizationToken: "",
    //                         deviceid: "WEB",
    //                         appLangCode: currentLanguage,
    //                     }
    //                 );

    //                 const data = JSON.parse(responseData);
    //                 // alert(JSON.stringify(Data.textFour));
    //                 // alert(Data.textFour); 
    //                 dispatch(genuityCheckData(data));
    //                 setWheelItems(data.wheelItems);
    //                 setCenterWheelImgUrl(data.centerWheelImgUrl);
    //                 const strongarmObject = JSON.parse(responseData).strongArmObject;
    //                 console.log(JSON.stringify(reqObj) + "reqObjReward Journey");
    //                 console.log(JSON.stringify(responseData));
    //                 const parseData = JSON.parse(JSON.stringify(strongarmObject));
    //                 setData(parseData);
    //                 setTitleOneListData(parseData.titleOneList);
    //                 setTitleTwoListData(parseData.titleTwoList);
    //             } catch (error) {
    //                 console.error("Error fetching API:", error);
    //             } finally {
    //                 setLoading(false);
    //             }
    //         };

    //         getScan();
    //     }
    // }, [reqObj, cid, mbno, currentLanguage]);



    const handleAllProductScanned = () => {
        setAllProductsScanned(true);
    };

    const handleSpinNow = () => {
        setWinBumperGiftsModal(true);
    };

    const handleSpinModalShow = () => {
        setEligibletoWinModal(false);
        setWinBumperGiftsModal(false);
        setSpinModalShow(true);
    };

    const handleEligible = () => {
        setWinBumperGiftsModal(false);
        if (Data.eligibleForBumperGift) {
            setSpinModalShow(true);
        } else {
            setEligibletoWinModal(true);
        }
    };

    const handleSpin = () => {
        setSpinDisabled(true);
        dispatch(spinStatus(true));
    };

    const handleCloseModal = () => {
        setWinBumperGiftsModal(false);
        setEligibletoWinModal(false);
        setSpinModalShow(false);
        setAllProductsScanned(false)
    };

    let bannerLogoSrc;
    if (lang === 'hi') {
        bannerLogoSrc = SpinImageHi;
    } else if (lang === 'mr') {
        bannerLogoSrc = SpinImageMr;
    } else if (lang === 'kn') {
        bannerLogoSrc = SpinImageKa;
    } else if (lang === 'te') {
        bannerLogoSrc = SpinImageTe;
    } else if (lang === 'pa') {
        bannerLogoSrc = SpinImagePb;
    } else if (lang === 'gu') {
        bannerLogoSrc = SpinImageGj;
    } else if (lang === 'ta') {
        bannerLogoSrc = SpinImageTa;
    } else if (lang === 'bn') {
        bannerLogoSrc = SpinImageBn;
    } else if (lang === 'en') {
        bannerLogoSrc = SpinImageEn;
    } else if (lang === 'or') {
        bannerLogoSrc = SpinImageHi;
    } else if (lang === 'ma') {
        bannerLogoSrc = SpinImageHi;
    }
    else {
        bannerLogoSrc = SpinImageHi;
    }

    // const openSpinWheel = () => {
    //     setSpinModalShow(true);
    // };

    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
              .modal-backdrop {
                background-color: transparent !important;
              }
              .modal-backdrop.show {
                opacity:1 !important;
              } 
              body{
              background-color:white !important;
              }
              .modal-content {
                border-radius: 10px !important;
                position:absolute !important;
                bottom:-10px !important;
                box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.5) !important;
                }
                .modal-dialog{
                margin:0px !important;
                width:100% !important;
                }
                .modal-body{
                margin-top:1rem;
                }
                
            `;
        document.head.appendChild(style);
        return () => {
            document.body.style.backgroundColor = '';
            document.head.removeChild(style);
        };
    }, []); 

    return (
        <>
            <Header navbarWhite={true} />
            {loading && <Loader />}

            <div className='mainSec px-2 mt-3'>
                <div className='px-3'>
                    {/* Top Stats */}
                    <div className="d-flex justify-content-between items-center mb-2">
                        {/* Packets */}
                        <div className="text-center">
                            <p className="infoHeading mb-0">
                                {t('rewardJourney.packetsScannedLabel')}
                            </p>
                            <div className="flex items-center justify-center gap-1">
                                <img src={giftBox} alt='giftBox' className='img-fluid mr-2' />
                                <span className="infoHeading">
                                    {Number(genuityCheckData?.scanCount ?? 0) || 0}
                                </span>
                            </div>
                        </div>

                        {/* Cashback */}
                        <div className="text-center">
                            <p className="infoHeading mb-0">
                                {t('rewardJourney.totalCashbackLabel')}
                            </p>
                            <div className="flex items-center justify-center gap-1">
                                <img src={rupeeSymbol} alt='giftBox' className='img-fluid mr-2' />
                                <span className="infoHeading">
                                    {Math.round(Number(genuityCheckData?.totalCashRewards) || 0)}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Cashback Banner */}
                    <div className="relative w-full">
                        <img
                            src={giftBg}
                            alt="giftBg"
                            className="giftBg w-full img-fluid"
                        />

                        {/* Center Text */}
                        <div className="absolute centerText z-10">
                            {/* <span className="winnerAmount">
                                {genuityCheckData?.cashRewards || 0}
                            </span> */}
                            <span className="winnerAmount">
                                {Number(genuityCheckData?.cashRewards || 0) % 1 === 0
                                    ? Number(genuityCheckData?.cashRewards || 0)
                                    : Number(genuityCheckData?.cashRewards || 0).toFixed(2)}
                            </span>
                        </div>

                        <p className='winnerInfoText absolute text-center'>
                            {primaryMessageBackend ? (
                                renderBackendMessage(primaryMessageBackend)
                            ) : (
                                t('rewardJourney.bannerCashbackFallback', {
                                    // amount:
                                    //     Number(genuityCheckData?.cashRewards || 0) % 1 === 0
                                    //         ? Number(genuityCheckData?.cashRewards || 0)
                                    //         : Number(genuityCheckData?.cashRewards || 0).toFixed(2),
                                })
                            )}
                        </p>
                    </div>

                    <div className="levelCard mt-2">
                        <h2 className="levelTitle">
                            {t('rewardJourney.nearNextLevelTitle')}
                        </h2>

                        <div className="progressWrapper">
                            <div className="progressBox">
                                {[...Array(totalBoxes)].map((_, i) => (
                                    <div
                                        key={i}
                                        className={`progressItem ${i < activeCount ? "active" : "pending"
                                            }`}
                                    >
                                        {i === activeCount - 1 && (
                                            <div className="progressArrow"><img src={line} alt='line' className='img-fluid lineImg' /></div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>


                        {/* Bottom Labels */}
                        <div className="progressLabels">
                            <span>
                                {t('rewardJourney.scansDone', {
                                    count: genuityCheckData.scanCount || 0,
                                })}
                            </span>
                            <span>
                                {t('rewardJourney.remaining', {
                                    count: Math.max(0, totalBars - genuityCheckData.scanCount),
                                })}
                            </span>
                        </div>

                        {/* Bottom Text — backend SecondaryMessage overrides copy */}
                        <p className="levelDesc mb-0">
                            {genuityCheckData?.nextLevelMsg}
                        </p>
                    </div>

                    <div className="buttonContainer">
                        <button
                            type="button"
                            className="actionBtn btnshadow"
                            onClick={() => navigate(`/${i18n.language}/scanproduct`) }
                        >
                            {t('rewardJourney.scanMorePackets')}
                        </button>

                        <button
                            type="button"
                            className="actionBtn btnshadow"
                            onClick={() => setShowProceedModal(true)}
                        >
                            {t('rewardJourney.proceed')}
                        </button>
                    </div>

                </div>

                <CustomModal
                    show={showProceedModal}
                    onHide={() => setShowProceedModal(false)}
                    title=""
                    content={
                        <div>
                            <h5 className='confirmHeading'>{t('rewardJourney.waitTitle')}</h5>
                            <div className="progressWrapper">
                                <div className="progressBox m-0">
                                    {[...Array(totalBoxes)].map((_, i) => (
                                        <div
                                            key={i}
                                            className={`progressItem ${i < activeCount ? "active" : "pending"}`}
                                        >
                                            {/* {i === activeCount - 1 && (
                                                <div className="progressArrow">
                                                    <img src={line} alt='line' className='img-fluid lineImg' />
                                                </div>
                                            )} */}
                                        </div>
                                    ))}
                                </div>
                                <div className="giftBoxContainer">
                                    <img src={giftbox1} alt='giftBox' className='img-fluid giftBoxImg' />
                                </div>
                            </div>


                            <div className="progressLabels m-0 p-0">
                                <span>
                                    {t('rewardJourney.scansDone', {
                                        count: genuityCheckData.scanCount || 0,
                                    })}
                                </span>
                                <span>
                                    {t('rewardJourney.remaining', {
                                        count: Math.max(0, totalBars - genuityCheckData.scanCount),
                                    })}
                                </span>
                            </div>

                            <div className='mt-5'>
                                <p className="text-left font-bold">
                                    {t('rewardJourney.confirmScannedHeading')}
                                </p>
                                <p className="text-left">
                                    {t('rewardJourney.confirmScannedBody')}
                                </p>
                            </div>
                        </div>
                    }
                    footer={
                        <>
                            <div className="buttonContainer w-100 mt-4">
                                <button className="actionBtn btnshadow w-100" onClick={() => { navigate(`/${i18n.language}/scanproduct`) }} >
                                    {t('rewardJourney.scanMorePackets')}
                                </button>
                                <button className="actionBtn btnshadow w-100" onClick={() => { navigate(`/${i18n.language}/paymentmode`) }} >
                                    {t('rewardJourney.proceed')}
                                </button>
                            </div>
                        </>
                    }
                />

                {/* <div className='BannerImgSec w-100'>
                    <div className='BannerImg'>
                        <div> 
                            <img src={Data.bgImageUrl} alt='winBig' className='img-fluid' />
                        </div>

                        <div className='winBigSec'> 
                            {Data.textTwo && (<p className='mb-1'>
                                <img src={ProductId} alt="ProductId" className='img-fluid ProductIdImg'
                                /> {Data.textTwo}</p>)}

                            {Data.textThree && (
                                <p className='mb-1 mt-2'> <img src={packetIcon} alt="packetIcon"
                                    className='img-fluid packetIcon' /> {Data.textThree}</p>
                            )}

                        </div>
                    </div>

                    {Data.textFour && (<p className='text-center mr-2 mt-3 scanMoreTitle'>
                        {Data.textFour}
                    </p>)}

                    <div className='px-3'>

                        <div className='card giftsCard'>
                            {Data.titleOne && (<div className='card-header btn-secondary cardText'>
                                {Data.titleOne}
                            </div>)}

                            <div className="card-body py-3" style={{ position: 'relative' }}>

                                {Data.eligibleForBumperGift && (<div className='giftsDisabled' />)}

                                <div style={{ display: 'grid', gap: '10px', gridTemplateColumns: 'repeat(3, 1fr)', placeItems: 'center' }}>
                                    {titleOneListData.map((item, key) => {

                                        const itemsPerRow = 3;
                                        const isFirstInRow = key % itemsPerRow === 0;
                                        const isLastInRow = (key + 1) % itemsPerRow === 0 || key === titleOneListData.length - 1;

                                        const borderStyle = {
                                            border: '1px solid #0D7C69',
                                            position: 'relative',
                                            borderTopLeftRadius: isFirstInRow ? '15px' : '0',
                                            borderBottomLeftRadius: isFirstInRow ? '15px' : '0',
                                            borderTopRightRadius: isLastInRow ? '15px' : '0',
                                            borderBottomRightRadius: isLastInRow ? '15px' : '0',
                                        };

                                        const imageStyle = {
                                            ...(isFirstInRow && {
                                                borderTopLeftRadius: '15px',
                                                borderBottomLeftRadius: '15px',
                                            }),
                                            ...(isLastInRow && {
                                                borderTopRightRadius: '15px',
                                                borderBottomRightRadius: '15px',
                                            }),
                                        };

                                        return (
                                            <div key={key} className='' style={borderStyle}>
                                                <img src={giftBg} alt="giftBg" className="img-fluid" style={imageStyle} />
                                                <div className='text-center'>
                                                    <img src={item.imageUrl} alt='cooker' className='img-fluid giftImg-Sec' style={{ width: '55px' }} />
                                                    <p className="image-text mb-0">{item.name}</p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>


                        <div className='card giftsCard mt-2'>
                            <div className='card-header btn-secondary cardText'>
                                {Data.titleTwo}
                            </div>
                            <div className="card-body py-3" style={{ position: 'relative' }}>

                                {!(Data.eligibleForBumperGift) && (<div className='giftsDisabled' />)}

                                <div className="" style={{ display: 'grid', gap: '10px', gridTemplateColumns: 'repeat(2, 1fr)', placeItems: 'center' }}>
                                    {titleTwoListData.map((item, key) => {
                                        const itemsPerRow = 2;
                                        const isFirstInRow = key % itemsPerRow === 0;
                                        const isLastInRow = (key + 1) % itemsPerRow === 0 || key === titleTwoListData.length - 1;

                                        const borderStyle = {
                                            border: '1px solid #0D7C69',
                                            position: 'relative',
                                            borderTopLeftRadius: isFirstInRow ? '15px' : '0',
                                            borderBottomLeftRadius: isFirstInRow ? '15px' : '0',
                                            borderTopRightRadius: isLastInRow ? '15px' : '0',
                                            borderBottomRightRadius: isLastInRow ? '15px' : '0',
                                        };

                                        const imageStyle = {
                                            ...(isFirstInRow && {
                                                borderTopLeftRadius: '15px',
                                                borderBottomLeftRadius: '15px',
                                            }),
                                            ...(isLastInRow && {
                                                borderTopRightRadius: '15px',
                                                borderBottomRightRadius: '15px',
                                            }),
                                        };

                                        return <div key={key} className='' style={borderStyle}>
                                            <img src={giftBg2} alt="giftBg2" className="img-fluid" style={imageStyle} />
                                            <div className=' text-center'>
                                                <img src={item.imageUrl} alt='cooker' className='img-fluid giftImg-Sec' style={{ width: '55px' }} />
                                                <p className="image-text mb-0">{item.name}</p>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>

                        </div>

                        <div className="d-flex gap-4">

                            <button className={`btn mb-4 submitBtn text-center btn-secondary w-100 
                        updateButton center-textbtn mt-3 bg-white text-secondaryColor`} onClick={() => {
                                    ReactGA.event({
                                        category: 'User Scan More',
                                        action: 'Clicked the Scan More Button',
                                    });
                                    navigate(`/${lang}/scanProduct`)
                                }}>
                                {t('Scanmore')}
                            </button>

                            <button
                                className="btn mb-4 submitBtn text-center btn-secondary w-100 updateButton center-textbtn mt-3 text-white"
                                onClick={() => {
                                    if (!(scanResponseData.isSpinDone || spinDisabled)) {
                                        handleAllProductScanned();
                                    }
                                }}
                                disabled={scanResponseData.isSpinDone || spinDisabled}
                            >
                                {t('Spin_Now')}
                            </button>

                        </div>
                    </div>
                </div> */}
            </div>


            {/* spin modal */}
            <CustomModal
                id={"spinModal"}
                title={
                    <>
                        <div className='d-flex align-items-center '>
                            <h5 className="mb-0 font-bold">{t('Spin_Wheel')}</h5>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={handleCloseModal}>
                                <img src={Close} alt="Close"
                                    className="button-Close"
                                />
                            </button>
                        </div>
                        <hr></hr>
                    </>
                }
                content={
                    <>
                        <div>
                            <CustomRoulette
                                wheelItems={wheelItems}
                                stopPrizeNumber={stopPrizeNumber}
                                closeModal={handleCloseModal}
                                spinInnerImage={centerWheelImgUrl}
                            />

                            <img src={stand} alt='stand' className='img-fluid standImg' />

                        </div>
                    </>
                }
                footer={
                    <>
                        {secondaryRewardMsg && (
                            <p className="text-center my-2" style={{ fontSize: ' 0.9rem' }} dangerouslySetInnerHTML={{ __html: secondaryRewardMsg.replace(/\n/g, '<br />') }}></p>)}
                        <Button onClick={handleSpin} className="btn-secondary py-2 rounded-4 mt-4 btnshadow" style={{ width: '93%' }}>
                            {t('Spin_Wheel_Win')}
                        </Button>
                    </>
                }
                show={spinModalShow}
                onHide={() => setSpinModalShow(false)}
            />

            {/* Win Bumper Gifts */}
            <CustomModal
                id={"winBumperGiftsModal"}
                title={
                    <>
                        <div className='d-flex align-items-center '>
                            <h5 className="mb-0 font-bold">{t('Spin_Win')}</h5>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={handleCloseModal}>
                                <img src={Close} alt="Close"
                                    className="button-Close"
                                />
                            </button>
                        </div>
                        <hr></hr>
                    </>
                }
                content={
                    <>

                        {!Data.eligibleForBumperGift && Data.bumperGiftTextOne && (
                            <h5 className='bumperGiftsTitle mb-2'>{Data.bumperGiftTextOne}</h5>
                        )}

                        {Data.eligibleForBumperGift && (
                            <h5 className='bumperGiftsTitle mb-4' style={{ fontWeight: '700' }}>{t('Eligible_to_win')}</h5>
                        )}

                        {!Data.eligibleForBumperGift && Data.bumperGiftTextTwo && (<p className="my-2 font-bold" style={{ fontSize: "18px" }}>
                            {Data.bumperGiftTextTwo}
                        </p>
                        )}

                        <div className='' style={{ display: 'grid', gap: '10px', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                            {titleTwoListData.map((item, key) => {
                                return <div key={key} className='d-flex' style={{ flexDirection: 'column', alignItems: "center" }}>
                                    <img src={item.imageUrl} alt='activa' className='img-fluid' style={{ width: "70px" }} />
                                    <p className='mb-0' style={{ fontSize: "14px", fontWeight: "600" }}>{item.name}</p>
                                </div>
                            })}

                        </div>


                        {Data.eligibleForBumperGift && (
                            <button className={`btn submitBtn text-center btn-secondary w-100 
               updateButton center-textbtn mt-3 text-white btnshadow`} onClick={handleEligible}>
                                {t('Continue')}
                            </button>
                        )}

                        {!Data.eligibleForBumperGift && (
                            <div className="d-flex gap-4">

                                <button className={`btn submitBtn text-center btn-secondary w-100 
                                    updateButton center-textbtn mt-3 bg-white text-secondaryColor btnshadow`} onClick={() => {
                                        ReactGA.event({
                                            category: 'User Scan More',
                                            action: 'Clicked the Scan More Button',
                                        });
                                        navigate(`/${lang}/scanProduct`)
                                    }}>
                                    {t('Scanmore')}
                                </button>

                                <button className={`btn submitBtn text-center btn-secondary w-100 
                          updateButton center-textbtn mt-3 text-white btnshadow`} onClick={handleEligible}>
                                    {t('Spin_Now')}
                                </button>

                            </div>
                        )}


                    </>
                }
                footer={""}
                show={winBumperGiftsModal}
                onHide={() => setWinBumperGiftsModal(false)}
            />

            {/* allProductsScanned */}
            <CustomModal
                id={"allProductsScannedModal"}
                title={
                    <>
                        <div className='d-flex align-items-center '>
                            <h5 className="mb-0 font-bold">{t('confirmation')}</h5>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={handleCloseModal}>
                                <img src={Close} alt="Close"
                                    className="button-Close"
                                />
                            </button>
                        </div>
                        <hr></hr>
                    </>
                }
                content={
                    <>
                        <h5 className="bumperGiftsTitle mb-2">{t('All_products_Scanned')}</h5>

                        <div className="d-flex gap-4">

                            <button className={`btn submitBtn text-center btn-secondary w-100 
                          updateButton center-textbtn mt-3 bg-white text-secondaryColor btnshadow`} onClick={handleCloseModal}>
                                {t('No')}
                            </button>

                            <button className={`btn submitBtn text-center btn-secondary w-100 
                                    updateButton center-textbtn mt-3 btnshadow`} onClick={handleSpinNow}>
                                {t('Yes')}
                            </button>

                        </div>

                    </>
                }
                footer={""}
                show={allProductsScanned}
                onHide={() => setAllProductsScanned(false)}
            />


            {/* Eligible to win Modal*/}
            <CustomModal
                id={"eligibletoWinModal"}
                title={
                    <>
                        <div className='d-flex align-items-center '>
                            <h5 className="mb-0 font-bold">{t('Spin_Win')}</h5>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={handleCloseModal}>
                                <img src={Close} alt="Close"
                                    className="button-Close"
                                />
                            </button>
                        </div>
                        <hr></hr>
                    </>
                }
                content={
                    <>
                        <h5 className='bumperGiftsTitle mb-2'>{Data.superGiftTextOne}</h5>
                        <div className='d-flex gap-4 mt-4' style={{ justifyContent: 'center' }}>
                            <div className='' style={{ display: 'grid', gap: '10px', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                {titleOneListData.map((item, key) => {
                                    return <> <div key={key} className='d-flex' style={{ flexDirection: 'column', justifyContent: "end", alignItems: "center" }}>
                                        <img src={item.imageUrl} alt='Spray_Pump' className='img-fluid' style={{ width: "60%" }} />
                                        <p className='mb-0' style={{ fontSize: "14px" }}>{item.name}</p>
                                    </div>
                                    </>
                                })}
                            </div>
                        </div>
                    </>
                }
                footer={
                    <button className={`btn submitBtn text-center btn-secondary w-100 
                        updateButton center-textbtn mt-3 text-white btnshadow`} onClick={handleSpinModalShow}>
                        {t('Continue')}
                    </button>
                }
                show={eligibletoWinModal}
                onHide={() => setEligibletoWinModal(false)}
            />

        </>
    )
}

export default RewardJourney
